import React, { useContext, useState } from 'react';
import { UserService } from 'core/api/services/user';
import { useAuth } from 'core/contexts/auth';

const UserContext = React.createContext(null);

export const UserProvider = ({ children }) => {
    const [loading, setLoading] = useState(false);
    const [users, setUsers] = useState([]);
    const [total, setTotal] = useState([]);

    const { userInfo, getUserInfo } = useAuth();

    const getUsers = async (options) => {
        try {
            setLoading(true);
            const result = await UserService.get(options);

            // location.reload();
            if (!result) {
                throw new Error();
            }
            setUsers(result.users);
            setTotal(result.total);

            return true;
        } catch (err) {
            console.error(err);
            return false;
        } finally {
            setLoading(false);
        }
    };

    const update = async (values) => {
        try {
            setLoading(true);
            const result = await UserService.update(values);

            if (!result) {
                throw new Error();
            }
            return result;
        } catch (err) {
            console.error(err);
            return false;
        } finally {
            setLoading(false);
        }
    };

    const unlock = async (id) => {
        try {
            setLoading(true);
            const result = await UserService.unlock(id);

            if (!result) {
                throw new Error();
            }
            return result;
        } catch (err) {
            console.error(err);
            return false;
        } finally {
            setLoading(false);
        }
    };

    return (
        <UserContext.Provider
            value={{
                getUsers,
                update,
                unlock,
                total,
                loading,
                users,
            }}>
            {children}
        </UserContext.Provider>
    );
};

UserProvider.displayName = 'UserProvider';

export const useUser = () => useContext(UserContext);
